import React from 'react';
import ReactSWF from 'react-swf';
import ReactOnRails from 'react-on-rails';

export default class AdditionHelper extends React.Component {

  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="addition-helper">
        <ReactSWF
          src="/assets/vt-aplusmath/flash/AddHelper.swf"
          id="guid_001"
          width="480"
          height="700"
          wmode="transparent"
        />
      </div>
    );
  }
}

ReactOnRails.register({AdditionHelper});



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/addition-helper/addition-helper.js
 **/